// extracted by mini-css-extract-plugin
export default {"backButton":"QTghqi","title":"fscCMb","list":"SwIuLN","optionButton":"LtuwiQ","optionTitle":"ulnQp4"};